import { ChatCard } from '@euler/app/flows/ai-suite/components/ChatCard';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { BiInsightProposalsWidgetPayload } from '@euler/model/bi/widgets';
import { Sparkles } from 'lucide-react-native';
import { memo } from 'react';
import { BiProposalAddButton } from './BiProposalAddButton';
import { BiProposalTiles } from './BiProposalTiles';
import { useBiProposalSelection } from './functions/useBiProposalSelection';

/** The proposals of one reply, and the button that adds the ticked ones. */
export const ProposalsCard = memo(
  ({ payload }: { payload: BiInsightProposalsWidgetPayload }) => {
    const selection = useBiProposalSelection();
    return (
      <ChatCard
        icon={Sparkles}
        color={aiColors.amber}
        title="推荐图表"
        subtitle={`挑出了 ${payload.draftIds.length} 张值得看的图表`}
      >
        <BiProposalTiles draftIds={payload.draftIds} selection={selection} />
        <BiProposalAddButton
          draftIds={payload.draftIds}
          selection={selection}
        />
      </ChatCard>
    );
  },
);
